module.exports = __webpack_public_path__ + "static/media/booking.89930705.svg";